import HR from '../../common/components/HR';
import {NavbarNotification} from '../../common/components/layout/LayoutProvider';
import {useI18n} from '../../common/providers/I18nProvider';
import {PageTitle} from '../../common/providers/PageDataProvider';
import Header from './components/Header';
import Notifications from './components/Notifications';
import Progress from './components/Progress';
import Schedule from './components/Schedule';
import useScheduleProgress from './pages/hooks/useScheduleProgress';

export default function Dashboard() {
	const {i18n} = useI18n();
	const {data} = useScheduleProgress();

	return (
		<>
			<PageTitle>{i18n('DASHBOARD.TITLE')}</PageTitle>
			<NavbarNotification />

			<div className='mb-6'>
				<Header />
			</div>

			<div className='sm:hidden mb-6 flex'>
				<HR />
			</div>

			<div className='mb-6'>
				<Notifications />
			</div>

			<div className='mb-6'>
				<Schedule scheduleData={data?.scheduledGroups} />
			</div>

			<div className='mb-6'>
				<Progress progressData={data?.progress} />
			</div>
		</>
	);
}
